import { createFileRoute } from "@tanstack/react-router";

import AccountPage from "@/admin/account/page";

export const Route = createFileRoute("/app/$storeId/account")({
    component: AccountPage,
});
